var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_441_1108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_441_1108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.103699H0.725926V0.816662H0V0.103699Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_441_1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6682 0.38605C0.647541 0.38605 0.630527 0.403064 0.630527 0.423724V0.743747H0.0753472V0.188567H0.39537C0.41603 0.188567 0.433044 0.171554 0.433044 0.150894C0.433044 0.130032 0.41603 0.11322 0.39537 0.11322H0.0376736C0.0168114 0.11322 0 0.130032 0 0.150894V0.78142C0 0.80208 0.0168114 0.819094 0.0376736 0.819094H0.6682C0.689063 0.819094 0.705874 0.80208 0.705874 0.78142V0.423724C0.705874 0.403064 0.689063 0.38605 0.6682 0.38605Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_441_1108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.259277 -1.52588e-05H0.816685V0.570355H0.259277V-1.52588e-05Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_441_1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.781413 -1.52588e-05H0.554156C0.533496 -1.52588e-05 0.516482 0.0169986 0.516482 0.0376583C0.516482 0.0585206 0.533294 0.075332 0.554156 0.075332H0.690469L0.302593 0.463208C0.287807 0.477994 0.287807 0.501692 0.302593 0.516275C0.309885 0.523769 0.319607 0.527415 0.329329 0.527415C0.338849 0.527415 0.348571 0.523769 0.355863 0.516275L0.743739 0.128399V0.264713C0.743739 0.285575 0.76055 0.302386 0.781413 0.302386C0.802275 0.302386 0.819086 0.285575 0.819086 0.264713V0.0376583C0.819086 0.0169986 0.802072 -1.52588e-05 0.781413 -1.52588e-05Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_441_1108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 30,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37256 8.91852H33.0815V37.6226H4.37256V8.91852Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_441_1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5018 20.0478C30.6582 20.0478 29.9722 20.7339 29.9722 21.5773V34.5696H7.42817V12.0256H20.4205C21.2641 12.0256 21.9499 11.3396 21.9499 10.4959C21.9499 9.65255 21.2641 8.96652 20.4205 8.96652H5.90219C5.05858 8.96652 4.37256 9.65255 4.37256 10.4959V36.0956C4.37256 36.9392 5.05858 37.6252 5.90219 37.6252H31.5018C32.3452 37.6252 33.0312 36.9392 33.0312 36.0956V21.5773C33.0312 20.7339 32.3452 20.0478 31.5018 20.0478Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_441_1108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 22,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1777 4.37257H37.6225V25.8222H16.1777V4.37257Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_441_1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0939 4.37439H26.8746C26.031 4.37439 25.345 5.06041 25.345 5.90402C25.345 6.74742 26.0276 7.43345 26.8746 7.43345H32.4048L16.658 23.1768C16.0595 23.7753 16.0595 24.7414 16.658 25.3363C16.9553 25.6339 17.3475 25.7843 17.7394 25.7843C18.1315 25.7843 18.5235 25.6339 18.821 25.3363L34.5678 9.58955V15.1231C34.5678 15.9667 35.2503 16.6527 36.0974 16.6527C36.9408 16.6527 37.6268 15.9667 37.6268 15.1231V5.90402C37.6234 5.06041 36.9373 4.37439 36.0939 4.37439Z",
    fill: "#F2F2F2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_1108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.6504bae7b9520739dc482142e808d773.svg";
export { ForwardRef as ReactComponent };